export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powtórz operację"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Historia operacji"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista kont"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieznany błąd"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista tokenów"])}
}